import React, { useState } from 'react';
import axios from 'axios';

// The "commercial accounts are coming" signup on the landing page
// (docs/plans/commercial-pricing-spec.md, section 16). Posts to
// POST /api/waitlist/commercial, which answers the same 200 for a new email, a
// duplicate and a filled honeypot, so success here never says which it was.
//
// The "website" field is the honeypot: off-screen, out of the tab order and
// hidden from screen readers, so only a bot fills it. Styles live with the rest
// of the landing page's, in LandingPage.js.

const GENERIC_ERROR = 'Something went wrong. Please try again.';

function CommercialWaitlist() {
  const [email, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [website, setWebsite] = useState('');
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSending(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/waitlist/commercial`, {
        email,
        company_name: companyName,
        website,
      });
      setDone(true);
    } catch (err) {
      const message = err.response?.data?.error;
      setError(typeof message === 'string' && message ? message : GENERIC_ERROR);
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="commercial-section" id="commercial">
      <div className="commercial-container">
        <div className="commercial-badge">Next season</div>
        <h2 className="commercial-title">Commercial accounts are coming for the 2027&#8209;28 season</h2>
        <p className="commercial-subtitle">
          Lots, strip malls, churches and apartment complexes, priced per push, per storm or by
          contract, on the same routes as your driveways.
        </p>

        {done ? (
          <p className="commercial-done" role="status">
            You are on the list. We will email you when it is ready.
          </p>
        ) : (
          <form className="commercial-form" onSubmit={handleSubmit}>
            <div className="commercial-fields">
              <label className="commercial-field">
                <span className="commercial-label">Email</span>
                <input
                  type="email"
                  name="email"
                  required
                  autoComplete="email"
                  inputMode="email"
                  maxLength={255}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@yourcompany.com"
                />
              </label>
              <label className="commercial-field">
                <span className="commercial-label">Company name (optional)</span>
                <input
                  type="text"
                  name="company_name"
                  autoComplete="organization"
                  maxLength={255}
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </label>
            </div>
            <div className="commercial-trap" aria-hidden="true">
              <label>
                Website
                <input
                  type="text"
                  name="website"
                  tabIndex={-1}
                  autoComplete="off"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </label>
            </div>
            <button type="submit" className="btn-commercial" disabled={sending}>
              {sending ? 'Sending...' : 'Put me on the list'}
            </button>
            {error && <p className="commercial-error" role="alert">{error}</p>}
          </form>
        )}
      </div>
    </section>
  );
}

export default CommercialWaitlist;
